import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Text, HStack, Pressable, Icon } from "native-base";
import { Feather } from "@expo/vector-icons";
import { DraggableAttributes } from "@dnd-kit/core";

type Props = {
  areaId: string;
  title: string;
  projectId: string;
  objectId: string;
  level: number;
  cracksCount: number;
  canAddCracks: boolean;
  isLoadingCracks: boolean;
  rootAreaTypeForChilden: string;
  attributes: DraggableAttributes;
  listeners?: any;
  canCollapse?: boolean;
  isExpanded?: boolean;
  onToggleExpand?: () => void;
};

export default function AreaItem({
  areaId,
  title,
  projectId,
  objectId,
  level,
  cracksCount,
  canAddCracks,
  isLoadingCracks,
  rootAreaTypeForChilden,
  attributes,
  listeners,
  canCollapse,
  isExpanded,
  onToggleExpand,
}: Props) {
  const navigate = useNavigate();

  const levelToFontSize: any = {
    1: "lg",
    2: "md",
  };

  return (
    <HStack alignItems="center">
      <Box w={6} alignItems="center" justifyContent="center">
        {canCollapse && onToggleExpand && (
          <Pressable
            onPress={onToggleExpand}
            _pressed={{ opacity: 0.5 }}
            hitSlop={{ top: 10, left: 10, right: 10, bottom: 10 }}
            accessibilityLabel={
              isExpanded
                ? "Unterbereiche einklappen"
                : "Unterbereiche ausklappen"
            }
          >
            <Icon
              as={Feather}
              name={isExpanded ? "chevron-down" : "chevron-right"}
              color="deepGreen"
            />
          </Pressable>
        )}
      </Box>
      <Pressable
        onPress={() => {
          navigate(
            ["/admin/projects", projectId, objectId, areaId].join("/") +
              `?rootAreaType=${rootAreaTypeForChilden}&level=${level}&canAdd=${canAddCracks}`
          );
        }}
        flexGrow={1}
      >
        {({ isHovered }) => (
          <HStack py={2.5} mr={4}>
            <Text
              fontSize={levelToFontSize[level] ?? "sm"}
              color={isHovered ? "moss.600" : "black"}
            >
              {title}
            </Text>

            {!isLoadingCracks && (canAddCracks || cracksCount > 0) && (
              <Text color={isHovered ? "moss.600" : "gray.500"} ml={2}>
                {cracksCount} {cracksCount === 1 ? "Riss" : "Risse"}
              </Text>
            )}
          </HStack>
        )}
      </Pressable>

      <span {...attributes} {...listeners} style={{ cursor: "grab" }}>
        <Icon as={Feather} name="move" color="deepGreen" />
      </span>
    </HStack>
  );
}
